import PushNotificationRepository from './pushNotification.repository';
import type { AdminPushNotificationPayload, PushSubscriptionPayload } from './pushNotification.model';

class PushNotificationService {
	static #instance: PushNotificationService;
	private readonly repository;

	private constructor() {
		this.repository = PushNotificationRepository.getInstance();
	}

	public static getInstance(): PushNotificationService {
		if (!PushNotificationService.#instance) {
			PushNotificationService.#instance = new PushNotificationService();
		}

		return PushNotificationService.#instance;
	}

	getPublicKey() {
		return this.repository.getPublicKey();
	}

	subscribe(data: PushSubscriptionPayload) {
		return this.repository.subscribe(data);
	}

	unsubscribe(endpoint: string) {
		return this.repository.unsubscribe(endpoint);
	}

	sendFromAdmin(data: AdminPushNotificationPayload) {
		return this.repository.sendFromAdmin(data);
	}
}

export default PushNotificationService;
